export const AutoPauseSection = (props) => {
    const headline = props.headline || "Auto-pause at key moments";
    const subHeading = props.subHeading;
    const imageLeft = props.imageLeft;
    const imageRight = props.imageRight;
    return (<section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="d-block d-lg-none col-lg-5 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0",  }}>{subHeading}</p>
                          </div>
                      </div>
                      <div className="col-lg-7 col-12 text-center">
                        <div className="container">
                            <div className="row justify-content-center clearfix text-center align-self-center">
                                <div className="col-lg-6 col-12 px-lg-4 px-5 py-3">
                                    <img src={imageLeft.src} alt={imageLeft.alt} style={{marginBottom: '10px'}}/>
                                    <p >{imageLeft.caption}</p>
                                </div>
                                <div className="col-lg-6 col-12 px-lg-4 px-5 py-3">
                                    <img src={imageRight.src} alt={imageRight.alt} style={{marginBottom: '10px'}}/>
                                    <p >{imageRight.caption}</p>
                                </div>
                            </div>
                        </div>
                          
                      </div>
                      <div className="d-none d-lg-block col-lg-5 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 0px 0",  }}>{subHeading}</p>
                          </div>
                      </div>
                  </div>

              </div>
          </section> 
    
    );
}

export default AutoPauseSection;